import PropTypes from 'prop-types';

/**
 * "Promotion Code Copied!" dialog shown after a code is copied, before sending the
 * shopper to Amazon. Shared by the deal card and the product page.
 */
const PromoCodeModal = ({ code, onClose, onShop }) => (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    aria-labelledby="promoCodeModalLabel"
    aria-modal="true"
    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
  >
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title text-primary" id="promoCodeModalLabel">
            Promotion Code Copied!
          </h5>
          <button type="button" className="btn-close" onClick={onClose} aria-label="Close modal" />
        </div>
        <div className="modal-body">
          <p>Code <strong>{code}</strong> has been copied to your clipboard.</p>
          <p>Apply it at checkout on Amazon to get the discounted price.</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button type="button" className="btn btn-primary" onClick={onShop}>
            Yes, Shop Now
          </button>
        </div>
      </div>
    </div>
  </div>
);

PromoCodeModal.propTypes = {
  code: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onShop: PropTypes.func.isRequired,
};

export default PromoCodeModal;
